var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 371.3 101.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{fill:#2a343a;}.cls-3{fill:url(#linear-gradient);}.cls-4{fill:url(#linear-gradient-2);}.cls-5{fill:#bbcede;}.cls-6{fill:#678aa7;}.cls-7{fill:url(#linear-gradient-3);}.cls-8{fill:#48637c;}.cls-9{fill:url(#linear-gradient-4);}.cls-10{fill:#99b6cd;}.cls-11,.cls-12{fill:#587791;}.cls-12{opacity:0.5;mix-blend-mode:multiply;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 71.83,
    y1: 23.42,
    x2: 112.23,
    y2: 89.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#99b6cd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#779dbc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 103.6,
    y1: 47.61,
    x2: 68.44,
    y2: 21.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dde7ee"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 32.96,
    y1: 42.23,
    x2: 17.81,
    y2: 79.64,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 57.32,
    y1: 57.27,
    x2: 26.65,
    y2: 41,
    xlinkHref: "#linear-gradient-2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M139.3,67.3l14.4-33.2h5.2l14.3,33.2h-6.5l-2.8-6.7H148.6l-2.8,6.7Zm11.3-11.6H162l-5.7-13.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M188,67.3V34.1h5.2l12.3,18.6,12.3-18.6H223V67.3h-5.8V44.8L205.5,62.3,193.8,44.8V67.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M240.5,67.3V34.1h22.2v5.4H246.6v7.9h16.1v5.4H246.6v9.1h16.1v5.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M278.8,67.3V34.1h13.3a11.3,11.3,0,0,1,7.9,3,9.7,9.7,0,0,1,3.3,7.5A10.1,10.1,0,0,1,297,54l8.3,13.3h-6.9L291,55.5h-6.1V67.3Zm6.1-17.2h6.6c3.3,0,5.7-2.2,5.7-5.4a5.1,5.1,0,0,0-5.2-5.2h-7.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M323,63a16.8,16.8,0,0,1,0-24.5,19,19,0,0,1,25.7,0,16.8,16.8,0,0,1,0,24.5A19.3,19.3,0,0,1,323,63Zm4.2-3.8a12.6,12.6,0,0,0,17.2,0,12,12,0,0,0,0-16.9,12.6,12.6,0,0,0-17.2,0,11.5,11.5,0,0,0-3.4,8.5A11.4,11.4,0,0,0,327.2,59.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M361.9,39.1V34.4h-1.5v-.9h4v.9h-1.5v4.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M365.6,39.1V33.5h.9l2,3.2,2-3.2h.8v5.6h-.9V35.3l-1.9,3-1.9-3v3.8Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "117.7 77.4 89.4 77.4 72.9 48.9 58.9 24.5 73 0 117.7 77.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "73 0 73 48.9 72.9 48.9 58.9 24.5 73 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "73 48.9 117.7 77.4 73 0 73 48.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "58.9 57.9 28.3 77.4 44.7 48.9 58.9 57.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "44.7 48.9 28.3 77.4 0 77.4 44.7 0 58.9 24.5 44.7 48.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "89.4 77.4 28.3 77.4 58.9 57.9 89.4 77.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "44.7 0 44.7 48.9 0 77.4 44.7 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "72.9 48.9 58.9 57.9 44.7 48.9 58.9 24.5 72.9 48.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "58.9 24.5 44.7 48.9 44.7 48.9 44.7 0 58.9 24.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "89.4 77.4 58.9 57.9 72.9 48.9 89.4 77.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "14.1 101.9 58.9 77.4 58.9 57.9 28.2 77.4 14.1 101.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "103.6 101.9 58.9 77.4 58.9 57.9 89.5 77.4 103.6 101.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "89.4 77.4 28.2 77.4 58.9 57.9 89.4 77.4"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.e2a65bfba7eb1824a2c8e44b98324746.svg";
export { ForwardRef as ReactComponent };